<template>
    <div class="activevaluebannner_container" v-if="visible" @click.stop="handleClick">
        <span class="title">{{ title }}</span>
        <span class="detail">
            {{ subTitle }}
        </span>
        <div class="button">做任务</div>
    </div>
</template>

<script>
export default {
    name: 'ActiveValueBanner',
    props: {
        activeValueObj: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        title() {
            return `当前${this.activeValueObj.score}活力值`;
        },
        subTitle() {
            return `还需${this.activeValueObj.differenceOfNextLockScore}活力值解锁${this.activeValueObj.nextAwardAmount}${this.activeValueObj.nextAwardTypeDesc}`;
        },
        page() {
            let typeValue = Number(this.$route.query.type);
            if (typeValue === 0) {
                return '等级权益-免息券详情页';
            }
            if (typeValue === 1) {
                return '等级权益-还款券详情页';
            }
            if (typeValue === 14) {
                return '等级权益-话费券详情页';
            }
            if (typeValue === 6) {
                return '等级权益-息费折扣券页';
            }
            return '';
        },
        eventId() {
            let typeValue = Number(this.$route.query.type);
            if (typeValue === 0) {
                return 'grade_freeCoupon';
            }
            if (typeValue === 1) {
                return 'grade_repayment';
            }
            if (typeValue === 14) {
                return 'grade_phone';
            }
            if (typeValue === 6) {
                return 'grade_xfzkqy';
            }
            return '';
        },
        tgtName() {
            let typeValue = Number(this.$route.query.type);
            if (typeValue === 0) {
                return '等级权益-免息券详情页-任务引导栏';
            }
            if (typeValue === 14) {
                return '等级权益-话费券详情页-任务引导栏';
            }
            if (typeValue === 1) {
                return '等级权益-还款券详情页-任务引导栏';
            }
            if (typeValue === 6) {
                return '等级权益-息费折扣券页-任务引导栏';
            }
            return '';
        }
    },
    watch: {
        visible: {
            handler: function(val) {
                if (val) {
                    this.exposureBanner();
                }
            },
            immediate: true
        }
    },
    methods: {
        handleClick() {
            this.exposureClickBanner();
            this.$emit('show-popup');
        },
        // banner位曝光事件埋点
        exposureBanner() {
            this.POINT('h5_element_imp', {
                page: `super-${this.page}`,
                tgt_event_id: `h5_ACT_${this.eventId}_taskydl`,
                tgt_name: `h5-ACT-${this.tgtName}`,
                param: this.activeValueObj.isOldCustomer === true ? this.activeValueObj.score : -1,
                param1: `${this.activeValueObj.allScore}`,
                param2: `${this.title}-${this.subTitle}`
            });
        },
        // banner点击事件埋点
        exposureClickBanner() {
            this.POINT('h5_clk', {
                page: `super-${this.page}`,
                tgt_event_id: `h5_ACT_${this.eventId}_taskydl`,
                tgt_name: `h5-ACT-${this.tgtName}`,
                param: this.activeValueObj.isOldCustomer === true ? this.activeValueObj.score : -1,
                param1: `${this.activeValueObj.allScore}`,
                param2: `${this.title}-${this.subTitle}`
            });
        }
    }
};
</script>

<style lang="less" scoped>
.activevaluebannner_container {
    margin: 0 auto;
    width: 339px;
    height: 80px;
    background: #fff7e5;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    .title {
        position: absolute;
        left: 18px;
        top: 21px;
        width: 96px;
        height: 17px;
        font-size: 14px;
        // font-family: 'fzlt_bold';
        font-weight: bold;
        color: #002a3c;
        line-height: 17px;
        white-space: nowrap;
    }
    .detail {
        position: absolute;
        left: 18px;
        top: 42px;
        width: 220px;
        height: 17px;
        font-size: 13px;
        // font-family: 'fzlt';
        color: #904e30;
        line-height: 17px;
        // white-space: nowrap;
    }
    .button {
        position: absolute;
        top: 26px;
        right: 18px;
        width: 80px;
        height: 28px;
        background: linear-gradient(90deg, #f4d583 0%, #f0bc53 100%);
        border-radius: 14px;
        font-size: 14px;
        // font-family: 'fzlt_bold';
        font-weight: bold;
        color: #904e30;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>